import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcStethoscope = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 2a3 3 0 0 1 1.002 5.829v3.178a6 6 0 0 1-6 6H16V27h7.639v-1.107A3.501 3.501 0 0 1 24.5 19a3.5 3.5 0 0 1 1.14 6.81V29H14V17.007h-.998a6 6 0 0 1-6-6V7.83a3.001 3.001 0 1 1 2-.001v3.178a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4V7.83A3.001 3.001 0 0 1 22 2Zm2.5 19a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM22 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM8 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcStethoscope;
